import React, { useState, useEffect } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import "./ProdutosPage.css";
import { getProductById, getProductVariants, getProducts } from "../../services/api";
import LoadingIndicator from "../../components/LoadingIndicator/LoadingIndicator"; // ajuste o caminho conforme sua estrutura

const ProdutosPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const variantParam = queryParams.get("variant");

  const [produto, setProduto] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [selectedStock, setSelectedStock] = useState(0);
  const [variants, setVariants] = useState([]);
  const [allProdutos, setAllProdutos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Detecta se a tela é mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Busca os dados do produto e dos produtos em destaque
    Promise.all([
      getProductById(id),
      getProducts(),
      getProductVariants(id)
    ])
      .then(([productData, productsData, variantsData]) => {
        setProduto(productData);
        setAllProdutos(productsData);
        setVariants(variantsData);

        if (productData.variants && productData.variants.length > 0) {
          let variantToSelect = productData.variants[0];
          if (variantParam) {
            const found = productData.variants.find(
              (v) => String(v.tamanho) === variantParam
            );
            if (found) {
              variantToSelect = found;
            }
          }
          setSelectedPrice(variantToSelect.preco);
          setSelectedSize(variantToSelect.tamanho);
          setSelectedStock(variantToSelect.estoque);
          setSelectedImage(variantToSelect.imagem_url || productData.imagem_url);
        } else {
          setSelectedImage(productData.imagem_url);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao carregar produto ou variantes:", error);
        setIsLoading(false);
      });

    window.scrollTo(0, 0);
  }, [id, variantParam]);

  const whatsappMessage = encodeURIComponent(
    `Olá, tenho interesse no ${produto?.titulo} no tamanho ${selectedSize}.`
  );
  const whatsappLink = `https://wa.me/5541998769002?text=${whatsappMessage}`;

  const selectedVariant =
    produto?.variants?.find((v) => v.tamanho === selectedSize) || null;
  const thumbnails = selectedVariant
    ? [selectedVariant.imagem_url, selectedVariant.imagem_url2].filter(Boolean)
    : [produto?.imagem_url, produto?.imagem_url2].filter(Boolean);

  // Enquanto os dados não forem carregados, exibe o loading indicator
  if (isLoading || !produto) {
    return <LoadingIndicator />;
  }

  // Cria um array "flattened" de todas as variantes de todos os produtos
  const flattenedProdutos = [];
  allProdutos.forEach((prod) => {
    if (prod.variants && prod.variants.length > 0) {
      prod.variants.forEach((variant) => {
        flattenedProdutos.push({
          ...prod,
          variant,
        });
      });
    } else {
      flattenedProdutos.push({ ...prod, variant: null });
    }
  });

  // Filtra para não exibir o produto atualmente selecionado
  const produtosDestaque = flattenedProdutos.filter((item) => {
    // Se for o mesmo produto do atual
    if (parseInt(item.id, 10) === parseInt(id, 10)) {
      // Se possuir variante, exclui apenas a variante que está selecionada
      if (item.variant) {
        return item.variant.tamanho !== selectedSize;
      }
      // Se não tiver variante, exclui o item (produto único)
      return false;
    }
    return true;
  });

  return (
    <section className="produto-detalhe-page">
      <div className="produto-detalhe-container">
        <div className="produto-image-container">
          <img
            src={selectedImage}
            alt={produto.titulo}
            className="produto-image-big"
          />
          <div className="produto-thumbnails-container">
            {thumbnails.map((img, index) => (
              <div
                key={index}
                className={`thumbnail ${selectedImage === img ? "selected" : ""}`}
                onClick={() => setSelectedImage(img)}
              >
                <img src={img} alt={`Thumbnail ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        <div className="produto-info-container">
          <div className="produto-header">
            <div className="breadcrumb">
              <Link to="/home" className="breadcrumb-link">
                Home
              </Link>
              <span className="breadcrumb-separator"> &gt; </span>
              <span className="breadcrumb-current">{produto.titulo}</span>
            </div>
            <h1 className="produto-title">{produto.titulo}</h1>
            <div className="preco-estoque">
              <p className="produto-preco">R$ {selectedPrice}</p>
              <p className="produto-estoque">Estoque: {selectedStock}</p>
            </div>
          </div>

          <hr className="divisoria" />

          <p className="produto-descricao">
            {produto.descricaoLonga ? produto.descricaoLonga : produto.descricao}
          </p>

          {/* Exibe apenas o tamanho selecionado */}
          {selectedSize && (
            <div className="tamanho-selecionado">
              <strong>Tamanho:</strong> {selectedSize}
            </div>
          )}

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-comprar"
          >
            COMPRAR
          </a>

          <ul className="lista-bolinhas">
            <li>Qualidade garantida</li>
            <li>Entrega para Campo Largo e região</li>
            <li>Apiário familiar</li>
            <li>Entre em contato agora</li>
          </ul>
        </div>
      </div>

      {/* Seção de produtos em destaque */}
      <div className="produtos-em-destaque">
        <div className="produtos-container">
          <h2 className="produtos-title">
            Produtos em destaque<span className="produtos-title-period">.</span>
          </h2>
          <hr className="produtos-divider" />
        </div>
        <div className="produtos-images-container">
          <div className="produtos-images">
            {produtosDestaque.map((item, index) => {
              const imageUrl = item.variant
                ? item.variant.imagem_url
                : item.imagem_url;
              const preco = item.variant ? item.variant.preco : item.preco;
              const estoque = item.variant ? item.variant.estoque : item.quantidade;
              const tamanho = item.variant ? item.variant.tamanho : null;
              return (
                <div key={index} className="produto-container">
                  <div className="produto-image-container">
                    <img
                      src={imageUrl}
                      className="produto-image"
                      alt={item.titulo}
                    />
                  </div>
                  <div className="produto-detalhes">
                    <div className="title-container">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="circle" />
                        <span className="title">{item.titulo}</span>
                        {tamanho && (
                          <span
                            style={{
                              marginLeft: "10px",
                              fontSize: "14px",
                              color: "#555",
                            }}
                          >
                            ({tamanho})
                          </span>
                        )}
                      </div>
                    </div>
                    <p className="descricao">{item.descricao}</p>
                    <div className="preco-estoque">
                      <span className="preco">R$ {preco}</span>
                      <span className="estoque">Estoque: {estoque}</span>
                    </div>
                    <Link
                      to={
                        item.variant
                          ? `/produtos/${item.id}?variant=${encodeURIComponent(
                              item.variant.tamanho
                            )}`
                          : `/produtos/${item.id}`
                      }
                      className="ver-mais-produto"
                    >
                      Ver Mais
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProdutosPage;
